import { render, staticRenderFns } from "./editPasswordDialog.vue?vue&type=template&id=2df5cc12"
import script from "./editPasswordDialog.vue?vue&type=script&lang=js"
export * from "./editPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./editPasswordDialog.vue?vue&type=style&index=0&id=2df5cc12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports